import React from "react";
import { useNavigate } from "react-router-dom";
import "./DealsDrawer.css";

export default function DealsDrawer({ open, onClose }) {

  const navigate = useNavigate();

  return (
    <>
      <div
        className={`drawer-overlay ${open ? "show" : ""}`}
        onClick={onClose}
      />

      <div className={`deals-drawer ${open ? "open" : ""}`}>

        <div className="drawer-header">
          <h3>💼 Deals</h3>
          <button onClick={onClose}>✕</button>
        </div>

        <div className="drawer-menu">

          <div
            className="drawer-item"
            onClick={() => {
              navigate("/deals");
              onClose();
            }}
          >
            Active Deals
          </div>

          <div
            className="drawer-item"
            onClick={() => {
              navigate("/deals/won");
              onClose();
            }}
          >
            Won Deals
          </div>

          <div
            className="drawer-item"
            onClick={() => {
              navigate("/deals/lost");
              onClose();
            }}
          >
            Lost Deals
          </div>

          <div
            className="drawer-item"
            onClick={() => {
              navigate("/reports");
              onClose();
            }}
          >
            Reports
          </div>

        </div>

      </div>
    </>
  );
}